import { Box, Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function NotificationSettings(props) {
  const { t } = useTranslation();
  const { allgNotiSettings, setAllgNotiSettings } = props;
  const [permissionDenied, setPermissionDenied] = useState(false);

  const changeArt = (art, key) => {
    setAllgNotiSettings((prev) =>
      prev.map((item) => (item.key === key ? { ...item, wert: art } : item)),
    );
  };

  useEffect(() => {
    checkPermission();

    const handleResume = () => {
      checkPermission();
    };

    document.addEventListener("resume", handleResume);

    return () => {
      document.removeEventListener("resume", handleResume);
    };
  }, []);

  const checkPermission = async () => {
    const isCordova = !!window.cordova;

    if (!isCordova) {
      return;
    }

    try {
      if (window.cordova) {
        window.FirebasePlugin.hasPermission((granted) => {
          setPermissionDenied(!granted);
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openSettings = () => {
    if (!window.cordova || !window.cordova.plugins || !window.cordova.plugins?.diagnostic) {
      console.error("Cordova or diagnostic plugin not available");
      return;
    }

    const diagnostic = window.cordova.plugins.diagnostic;
    diagnostic.switchToNotificationSettings(
      () => {
        console.log("Successfully opened settings");
      },
      (err) => {
        console.error("Error opening settings: ", err);
      },
    );
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
        {allgNotiSettings === undefined || allgNotiSettings?.length === 0 ? (
          <Typography style={{ textAlign: "center" }}>
            {t(
              "Aktuell gibt es keine Benachrichtigungen, die Sie einstellen können.",
            )}
          </Typography>
        ) : (
          <>
            {permissionDenied && (
              <Box
                sx={{
                  p: 3,
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 2,
                  textAlign: "center",
                  maxWidth: 450,
                  mb: 4,
                  mx: "auto",
                  bgcolor: "background.paper",
                }}
              >
                <Typography variant="h6" color="error" gutterBottom>
                  Push-Benachrichtigungen deaktiviert
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  Aktiviere Push-Benachrichtigungen in den Systemeinstellungen,
                  um wichtige Updates zu erhalten.
                </Typography>

                <Button variant="contained" onClick={openSettings}>
                  Einstellungen öffnen
                </Button>
              </Box>
            )}

            <Typography style={{ textAlign: "center", fontSize: 20 }}>
              {t("Auf welche Art wollen Sie ihre Benachrichtigungen erhalten?")}
            </Typography>
            {allgNotiSettings?.map((item) => (
              <>
                <Typography style={{ marginBottom: 6 }} variant="subtitle1">
                  {t(item.title)}
                </Typography>
                <TextField
                  style={{ marginBottom: 20 }}
                  fullWidth
                  label=""
                  value={item.wert}
                  onChange={(e) => changeArt(e.target.value, item.key)}
                  select
                >
                  <MenuItem value="0">E-Mail</MenuItem>
                  <MenuItem value="1">Push-Benachrichtigung</MenuItem>
                  <MenuItem value="2">Beides</MenuItem>
                  <MenuItem value="3">Keine Benachrichtigung</MenuItem>
                </TextField>
              </>
            ))}
          </>
        )}
      </Grid>
    </>
  );
}

export default NotificationSettings;
